import { useMemo } from 'react'
import { getPledges, Pledge } from '@/services/api/pledge'
import { whiteLabelUtil } from '@/services/api/siteAssets'
import useApi from '@/services/hooks/useApiV2'
import useAuth from '@/services/hooks/useAuth'
import useSiteAssets from '../useSiteAssets/useSiteAssets'

const useUserPledges = () => {
  const { user } = useAuth()
  const { domain } = useSiteAssets()

  const { data, isLoading, isError } = useApi<Pledge[]>({
    request: getPledges,
    key: user ? `pledges/${user.id}/` : false,
  })

  const userPledges = useMemo(
    () => data?.filter((c) => whiteLabelUtil.isAllowed(c, domain)),
    [data, domain]
  )

  return {
    userPledges,
    isLoading,
    isError,
  }
}

export default useUserPledges
